(function () {
  var menuButton = document.querySelector('.ff-burger');
  var menu = document.querySelector('.ff-menu');

  function closeMenu() {
    if (!menuButton || !menu) return;
    menu.classList.remove('ff-open');
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.setAttribute('aria-label', 'Open menu');
  }

  if (menuButton && menu) {
    menuButton.addEventListener('click', function () {
      var open = menu.classList.toggle('ff-open');
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) closeMenu();
    });
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.ff-site')) closeMenu();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenu();
    });
  }

  var filterButtons = Array.prototype.slice.call(document.querySelectorAll('[data-ff-filter]'));
  var collectionGrid = document.querySelector('[data-ff-grid]');
  var cards = collectionGrid ? Array.prototype.slice.call(collectionGrid.querySelectorAll('[data-ff-card]')) : [];

  function applyFilter(filter) {
    if (!cards.length) return;
    cards.forEach(function (card) {
      card.hidden = filter !== 'all' && card.dataset.category !== filter;
    });
    filterButtons.forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.ffFilter === filter));
    });
  }

  if (filterButtons.length && cards.length) {
    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        applyFilter(button.dataset.ffFilter || 'all');
      });
    });
    var initialFilter = new URLSearchParams(window.location.search).get('filter');
    if (initialFilter === 'mesh' || initialFilter === 'adjustable' || initialFilter === 'character') {
      applyFilter(initialFilter);
    }
  }

  var sortSelect = document.querySelector('[data-ff-sort]');
  if (sortSelect && collectionGrid && cards.length) {
    sortSelect.addEventListener('change', function () {
      var value = sortSelect.value;
      var sorted = cards.slice();
      if (value === 'low') sorted.sort(function (a, b) { return Number(a.dataset.price) - Number(b.dataset.price); });
      if (value === 'high') sorted.sort(function (a, b) { return Number(b.dataset.price) - Number(a.dataset.price); });
      sorted.forEach(function (card) { collectionGrid.appendChild(card); });
    });
  }

  var quantity = document.querySelector('[data-ff-quantity]');
  if (quantity) {
    var minus = document.querySelector('[data-ff-minus]');
    var plus = document.querySelector('[data-ff-plus]');
    if (minus) minus.addEventListener('click', function () {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', function () {
      quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });
    quantity.addEventListener('change', function () {
      var clean = parseInt(quantity.value, 10);
      quantity.value = Number.isFinite(clean) && clean > 0 ? clean : 1;
    });
  }

  var variantInput = document.querySelector('[data-ff-variant-id]');
  var productPrice = document.getElementById('FFProductPrice');
  var addButton = document.querySelector('[data-ff-add]');
  var optionSelects = Array.prototype.slice.call(document.querySelectorAll('[data-ff-option-index]'));
  var variantsElement = document.querySelector('[data-ff-product-variants]');
  if (optionSelects.length && variantsElement && addButton) {
    var variants = [];
    try {
      variants = JSON.parse(variantsElement.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    function selectedProductOptions() {
      return optionSelects.map(function (select) { return select.value; });
    }

    function updateOptionAvailability() {
      optionSelects.forEach(function (select, optionIndex) {
        Array.prototype.forEach.call(select.options, function (option) {
          var hasAvailableMatch = variants.some(function (variant) {
            if (!variant.available || variant.options[optionIndex] !== option.value) return false;
            return optionSelects.every(function (otherSelect, otherIndex) {
              return optionIndex === otherIndex || variant.options[otherIndex] === otherSelect.value;
            });
          });
          option.disabled = !hasAvailableMatch && !option.selected;
        });
      });
    }

    function updateSelectedVariant() {
      var values = selectedProductOptions();
      var variant = variants.find(function (candidate) {
        return optionSelects.every(function (select, index) {
          return candidate.options[index] === values[index];
        });
      });

      if (!variant) {
        addButton.disabled = true;
        return;
      }

      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (productPrice && variant.price) productPrice.textContent = variant.price;
     if (variant.image) {
  var mainImage = document.querySelector('.ff-pdp-gallery .ff-pdp-media[data-media-type="image"] img');
  if (mainImage) {
    mainImage.removeAttribute('srcset');
    mainImage.src = variant.image;
  }
}
      addButton.disabled = !variant.available;
      var addButtonLabel = addButton.querySelector('span') || addButton;
      var label = addButton.dataset.ffAddLabel || 'Add to cart';
      addButtonLabel.textContent = variant.available ? label + ' · ' + variant.price : 'Sold out';
      updateOptionAvailability();
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', updateSelectedVariant);
    });
    updateOptionAvailability();
  }

  document.querySelectorAll('.ff-size-link').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      if (target.tagName === 'DETAILS') target.open = true;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  function setCartCount(count) {
    var cartLink = document.querySelector('.ff-cart-count');
    var cartBadge = cartLink && cartLink.querySelector('i');
    if (!cartBadge || typeof count !== 'number') return;
    cartBadge.textContent = count;
    cartLink.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
  }

  var cartCountRefreshGeneration = 0;
  function refreshCartCountFromStore() {
    var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    fetch(cartUrl + '.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) { setCartCount(cart.item_count); })
      .catch(function () {});
  }

  function queueCartCountRefresh() {
    var generation = ++cartCountRefreshGeneration;
    [200, 450, 700, 950].forEach(function (delay) {
      window.setTimeout(function () {
        if (generation === cartCountRefreshGeneration) refreshCartCountFromStore();
      }, delay);
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.cart-remove-button, cart-drawer button, cart-items button, #main-cart-items button, #CartDrawer button, .cart-drawer button')) {
      queueCartCountRefresh();
    }
  });
  document.addEventListener('change', function (event) {
    if (event.target.closest('cart-drawer, cart-items, #main-cart-items, #CartDrawer, .cart-drawer, .cart-items')) {
      queueCartCountRefresh();
    }
  });

  function bindCartCount() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.cartData && typeof event.cartData.item_count === 'number') {
        setCartCount(event.cartData.item_count);
      }
      queueCartCountRefresh();
    });
    return true;
  }

  var cartCountBindAttempts = 0;
  function ensureCartCountBinding() {
    if (bindCartCount()) return;
    if (cartCountBindAttempts < 20) {
      cartCountBindAttempts += 1;
      window.setTimeout(ensureCartCountBinding, 50);
    }
  }
  ensureCartCountBinding();

  function styleRewardsLauncher(frame) {
    try {
      var frameDocument = frame.contentDocument;
      if (!frameDocument || !frameDocument.head) return;
      if (frameDocument.getElementById('ff-rewards-launcher-color')) return;
      var style = frameDocument.createElement('style');
      style.id = 'ff-rewards-launcher-color';
      style.textContent = 'button, button:hover, button:focus { background-color: #17706b !important; color: #fff !important; }';
      frameDocument.head.appendChild(style);
    } catch (error) {
      // Smile renders its launcher in an isolated frame; skip it if access is blocked.
    }
  }

  function findRewardsLauncher() {
    document.querySelectorAll('#smile-lite-launcher-frame').forEach(function (frame) {
      if (frame.dataset.ffBrandStyleAttached !== 'true') {
        frame.addEventListener('load', function () { styleRewardsLauncher(frame); });
        frame.dataset.ffBrandStyleAttached = 'true';
      }
      styleRewardsLauncher(frame);
    });
  }

  findRewardsLauncher();
  new MutationObserver(findRewardsLauncher).observe(document.documentElement, { childList: true, subtree: true });

  var cookieSettingsLink = document.querySelector('[data-ff-cookie-settings]');
  if (cookieSettingsLink) {
    cookieSettingsLink.addEventListener('click', function (event) {
      var cookieBox = document.querySelector('dbtfy-cookie-box');
      if (!cookieBox || typeof cookieBox.storageValue !== 'function') return;

      event.preventDefault();

      function cookieNoticeIsVisible() {
        var toastElement = cookieBox.toast && cookieBox.toast.toastElement;
        return !!toastElement && toastElement.isConnected && !toastElement.classList.contains('dbtfy-toast-hide');
      }

      if (cookieNoticeIsVisible()) return;

      var acceptedCountries = JSON.parse(window.localStorage.getItem('DebutifyCookieBox') || '[]');
      if (!Array.isArray(acceptedCountries)) acceptedCountries = [];
      window.localStorage.setItem('DebutifyCookieBox', JSON.stringify(
        acceptedCountries.filter(function (country) { return country !== cookieBox.country; })
      ));

      function reopenCookieNotice() {
        if (cookieNoticeIsVisible()) return;
        if (cookieBox.checkCountryEu === 'true' && typeof cookieBox.checkCountry === 'function') {
          cookieBox.checkCountry();
        } else {
          cookieBox.storageValue();
        }
      }

      var toastElement = cookieBox.toast && cookieBox.toast.toastElement;
      if (!toastElement || (toastElement.isConnected && toastElement.classList.contains('dbtfy-toast-hide'))) {
        window.setTimeout(reopenCookieNotice, 550);
      } else {
        reopenCookieNotice();
      }
    });
  }
})();
